/** @jsx jsx */
import { jsx } from '@emotion/react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import { Card, CardHeader, CardBody, CardFooter, CardTitle } from '../../card';
import Button from '../../button/button';
import ErrorMessage from '../../error-message';

const ErrorModalBody = ({ error, close }) => {
  return (
    error && (
      <Card modal>
        <CardHeader>
          <CardTitle>{get(error, 'name') || 'Error'}</CardTitle>
        </CardHeader>
        <CardBody>
          <ErrorMessage error={error} />
        </CardBody>
        <CardFooter>
          <Button autoFocus className="btn-primary" onClick={close}>
            Close
          </Button>
        </CardFooter>
      </Card>
    )
  );
};

ErrorModalBody.propTypes = {
  close: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      message: PropTypes.string,
      data: PropTypes.shape({
        errors: PropTypes.arrayOf(
          PropTypes.shape({
            message: PropTypes.string,
          }),
        ),
      }),
    }),
  ]),
};
ErrorModalBody.defaultProps = {
  error: null,
};

export default ErrorModalBody;
